module.exports = __webpack_public_path__ + "img/faulty_.cc41359d.svg";